module.exports = __webpack_public_path__ + "img/feature-5.0550e649.jpg";